import { render } from "./LocaleChanger.vue?vue&type=template&id=7251435e"
import script from "./LocaleChanger.vue?vue&type=script&lang=js"
export * from "./LocaleChanger.vue?vue&type=script&lang=js"

import "./LocaleChanger.vue?vue&type=style&index=0&id=7251435e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__